import { useCompanyStatusEnum } from './companies.enum'
import { ICompany, ICompanyRes } from './companies.type'

export const useConvertCompany = () => {
  const { toString } = useCompanyStatusEnum()
  const converter = (company: ICompanyRes): ICompany => {
    const _convert = (company: ICompanyRes, stackIndex: number): ICompany => {
      return {
        ...company,
        statusStr: toString(company.status),
        stackIndex,
        sessions: company.sessions?.map(d => _convert(d, stackIndex + 1)) || [],
      }
    }
    return {
      ...company,
      statusStr: toString(company.status),
      stackIndex: 0,
      sessions: company.sessions?.map(d => _convert(d, 1)) || [],
    }
  }
  return converter
}
